export default defineNuxtPlugin(async () => {
  const { getBuyingLists } = useBuyingList();
  const isAuthenticated = computed(() => useCookie('isAuthenticated').value);

  const params: any = {
    currency: 'EUR',
    pageable: { page: 0, size: 999 },
    status: ['INIT', 'LOADING', 'ON_GOING'].join(','), // Convert the array to a comma-separated string
  };

  try {
    //isAuthenticated.value ? await getBuyingLists(params, true) : null;
  } catch (error) {
    console.error('Error while fetching buyingList:', error);
  }
});
